export default __webpack_public_path__ + "static/media/spinner.2fd66c2e.svg";